module.exports = __webpack_public_path__ + "static/media/Inclined-Kids4.558a8e8b.jpg";